import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { NetworkStatusService } from './network-status.service';

@Component({
  selector: 'app-offline-banner',
  standalone: true,
  imports: [TranslateModule],
  template: `
    @if (!network.online()) {
      <div
        class="fixed bottom-4 left-1/2 z-[10000000] w-[calc(100%-20px)] max-w-[620px] -translate-x-1/2 rounded-[2px] bg-[var(--st-color-red)] px-8 py-3.5 text-center text-sm font-medium text-white opacity-90 shadow-[0_10px_15px_rgba(0,0,0,0.4)]"
        role="status"
        data-testid="app-network.status.offline"
        aria-live="polite">
        You're offline. The app will continue when your connection is restored.
      </div>
    }
  `,
})
export class OfflineBannerComponent {
  protected readonly network = inject(NetworkStatusService);
}
